import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";
import { MentionsInput, Mention } from "react-mentions";
import { useFormContext } from "./Form";
import { withFormWrapper, DEFAULT_ID } from "./withFormWrapper";
import { StaticInputValue } from "./StaticInput";
import { useTranslation } from "./hooks/useTranslation";
var RawMention = observer(function (_a) {
    var name = _a.name, onChange = _a.onChange, _b = _a.trigger, trigger = _b === void 0 ? "{" : _b, options = _a.options, type = _a.type, placeholder = _a.placeholder, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.singleLine, singleLine = _d === void 0 ? true : _d, _e = _a.uniqueId, uniqueId = _e === void 0 ? DEFAULT_ID : _e, label = _a.label, staticFormatter = _a.staticFormatter, dataId = _a.dataId, dataLabel = _a.dataLabel, dataTestId = _a.dataTestId;
    var _f = useFormContext(), values = _f.values, isStatic = _f.isStatic;
    var sortedOptions = options.sort(function (a, b) {
        return a.display.localeCompare(b.display);
    });
    var markup = type === "jinja" ? "{{__id__}}" : "__display__ ";
    var regex = /@(\S+)/;
    var emptyStringIfNull = function (value) {
        return value !== null ? value : "";
    };
    var getDisplayValue = function (id, display) {
        if (type === "jinja") {
            return "{{".concat(id, "}}");
        }
        return display;
    };
    var handleChange = useCallback(function (value) {
        onChange(value, values.get(name));
        values.set(name, value);
    }, [onChange, values, name]);
    var onAdd = function () {
        values.set(name, removeSpacesBetweenBraces(values.get(name)));
    };
    var removeSpacesBetweenBraces = function (value) {
        return value.replace(/\}.*?\{/g, function (value) {
            return value.replace(/\s/g, "");
        });
    };
    if (isStatic) {
        return (React.createElement(StaticInputValue, { label: label, name: name, staticFormatter: staticFormatter, dataId: dataId, dataLabel: dataLabel, dataTestId: dataTestId }));
    }
    var t = useTranslation();
    return (React.createElement(MentionsInput, { className: "mentions ".concat(singleLine ? "single" : ""), "aria-label": t("Mention"), value: emptyStringIfNull(values.get(name)), placeholder: placeholder, allowSpaceInQuery: true, disabled: disabled, onChange: function (_, newValue) { return handleChange(newValue); }, id: "form-group-".concat(name, "-").concat(uniqueId) },
        React.createElement(Mention, { trigger: trigger, data: sortedOptions, markup: markup, regex: regex, displayTransform: function (id, display) { return getDisplayValue(id, display); }, onAdd: onAdd, appendSpaceOnAdd: true })));
});
export var MentionInput = withFormWrapper({ WrappedComponent: RawMention });
